/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'
import zenaImage from '../assets/svg/testimonials/zena-testimony-image-1.png'
import abebeImage from '../assets/svg/testimonials/abebekebede-testimonial-1.png';


export const testimonialsData = [
    {
        id: 1,
        name: 'Zena Abebe',
        title: 'Manager - Abay Bank S.C',
        text: "Working with Bisrat was an absolute breeze! Not only did he develop a flawlessly functioning website, but he also infused it with his creative flair. He made the entire process a pleasure.",
        image: zenaImage
    },
    {
        id: 2,
        name: 'Abebe Kebede',
        title: 'Education Consultant - NC A&T State Universtiy',
        text: "I've worked with my fair share of developers, but Bisrat stands out by miles. He made the entire process seamless, delivering a stunning website that captures the essence of my brand.",
        image: abebeImage
    },
    {
        id: 3,
        name: 'Meaza Demissie',
        title: 'CMO - Addis One Studio',
        text: "As a girl in a tech-dominated industry, I felt supported and respected throughout the entire development process. I can't thank him enough for his fantastic work! Bravo Bisre :) !",
        image: girl3
    },
    // {
    //     id: 4,
    //     name: 'Joey Tribbiani',
    //     title: 'Actor',
    //     text: "Making my portfolio with this helped me get my role as 'Dr. Drake Ramoray' in 'Days Of Our Lives'. You guys are the best !",
    //     image: boy1
    // },
    // {
    //     id: 5,
    //     name: 'Rachel Green',
    //     title: 'Sales Executive',
    //     text: 'Ralph Lauren was one of the best things that ever happened to me. My portfolio made that dream happen. I owe you guys.',
    //     image: girl3
    // },
    // {
    //     id: 6,
    //     name: 'Ross Geller',
    //     title: 'Paleontologist',
    //     text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
    //     image: boy3
    // }
]

